import React, { useState } from 'react';
import Header from './components/Header';
import Main from './components/Main';
import Basket from './components/Basket';
import  productdata  from './components/ProductData';
import Links from "./components/Links";

function App() {
  const [ products ] = useState(productdata);
  const [cartItems, setCartItems] = useState([]);
  const [page, setPage] = useState(1);
  const [links, setLinks] = useState([]);
  const onAdd = (product) => {
  const exist = cartItems.find((x) => x.id === product.id);
  if (exist) {
    setCartItems(
      cartItems.map((x) =>
        x.id === product.id ? { ...exist, qty: exist.qty + 1 } : x
      )
    );
  } else {
    setCartItems([...cartItems, { ...product, qty: 1 }]);
  }
};
const onRemove = (product) => {
  const exist = cartItems.find((x) => x.id === product.id);
  if (exist.qty === 1) {
    setCartItems(cartItems.filter((x) => x.id !== product.id));
  } else {
    setCartItems(
      cartItems.map((x) =>
        x.id === product.id ? { ...exist, qty: exist.qty - 1 } : x
      )
    );
  }
};

const CartClear = () => {
  setCartItems([]);
}
  return (
    <>
    { page === 1 && 
    <div className="App">
      <Header countCartItems={cartItems.length}></Header>
      <div className="row">
        <Main products={products} onAdd={onAdd}></Main>
        <Basket
         
          cartItems={cartItems}
          onAdd={onAdd}
          onRemove={onRemove}
          CartClear={CartClear}
          setPage={setPage}
        ></Basket>
      </div>
    </div>
    
    }
    { page === 2 && 
    <div class="block col-3">
      <h3>Toimitustiedot</h3>

      <div className="">
        <Links 
          links={links} 
          setLinks={setLinks}
       
        />
      </div>
      
 
    </div>
    }
    </>

  );
}

export default App;